export default __webpack_public_path__ + "static/media/ceramx-ausgangssituation.747e2bb3.png";